module.exports = __webpack_public_path__ + "img/ground-river-morning.28b10716.png";